/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-useless-concat */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import * as d3 from 'd3';
import { interpolatePath } from 'd3-interpolate-path';

import { MOBILE_NAVIGATION } from '@app/app.constants';
import { GraphFilter, GraphFilterDays, GraphFilterSource, GraphFilterTimePeriod, Transaction, TransactionType } from '@shared/models/Reporting';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-reporting-chart-line-chart',
  styleUrls: ['./reporting-chart-line-chart.component.scss'],
  templateUrl: './reporting-chart-line-chart.component.html',
  standalone: false
})
export class ReportingLineChartComponent implements OnInit, OnChanges {
  @Input() currency: string;
  @Input() currentLang: string;
  @Input() data: Array<any>;
  @Input() daysDifference: number;
  @Input() filterConfig: GraphFilter;
  @Input() hideDepositsTransfers: boolean;
  @Input() hideWithdrawals: boolean;
  @Input() transactionsTypeDepositTransfer: Array<any>;
  @Input() transactionsTypeWithdrawal: Array<any>;
  private grid: any;
  private height: number;
  private line: any;
  private margin = { top: 10, bottom: 10, left: 0, right: 0 };
  private width: number;
  private xAxis: any;
  private xScale: any;
  private yAxis: any;
  private yScale: any;

  cssReportingChartColor = getComputedStyle(document.documentElement).getPropertyValue('--reporting-chart-color');
  cssReportingChartTooltipColor = getComputedStyle(document.documentElement).getPropertyValue('--reporting-chart-tooltip-color');
  cssReportingChartShadowColor = getComputedStyle(document.documentElement).getPropertyValue('--reporting-chart-shadow-color');
  cssGreyColor = getComputedStyle(document.documentElement).getPropertyValue('--grey');

  ngOnInit(): void {
    this.drawChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && !changes.data.firstChange) {
      const redraw = changes.filterConfig && changes.filterConfig.currentValue.source !== changes.filterConfig.previousValue.source;
      this.updateChart(changes.data.currentValue, redraw);
    }
  }

  drawChart(): void {
    this.height = 250;
    this.width = window.innerWidth >= 1180 ? 1180 : window.innerWidth - 20;

    // Create line
    this.line = d3
      .line()
      .defined((d: any) => d.value)
      .x((d: any) => this.xScale(d.date))
      .y((d: any) => this.yScale(d.value));

    // Select main SVG
    const svg = d3
      .select('.line-chart')
      .attr('width', this.width)
      .attr('height', this.height)
      .style('-webkit-tap-highlight-color', 'transparent')
      .style('overflow', 'visible');

    const min = d3.min(this.data, (d) => d.value);
    const max = d3.max(this.data, (d) => d.value);

    const formatDate = (date: Date) => {
      if (this.filterConfig && this.filterConfig.timePeriod === GraphFilterTimePeriod.WEEK) {
        return new Intl.DateTimeFormat(this.currentLang, { weekday: 'short', day: '2-digit' }).format(date);
      }
      if (
        (this.filterConfig && this.filterConfig.timePeriod === GraphFilterTimePeriod.MONTH) ||
        (this.filterConfig && this.filterConfig.timePeriod === GraphFilterTimePeriod.QUARTER)
      ) {
        return new Intl.DateTimeFormat(this.currentLang, { month: 'short', day: '2-digit' }).format(date);
      }

      if (
        (this.filterConfig && this.filterConfig.timePeriod === GraphFilterTimePeriod.MAX) ||
        (this.filterConfig && this.filterConfig.timePeriod === GraphFilterTimePeriod.MORE_YEAR)
      ) {
        if (this.daysDifference > 720) {
          return new Intl.DateTimeFormat(this.currentLang, { year: 'numeric', month: 'short' }).format(date);
        }
        if (this.daysDifference > 90) {
          return new Intl.DateTimeFormat(this.currentLang, { month: 'short' }).format(date);
        }
        if (this.daysDifference > 30) {
          return new Intl.DateTimeFormat(this.currentLang, { month: 'short', day: '2-digit' }).format(date);
        }
        return new Intl.DateTimeFormat(this.currentLang, { weekday: 'short', day: '2-digit' }).format(date);
      }
      return new Intl.DateTimeFormat(this.currentLang, { month: 'short' }).format(date);
    };

    // Create scales
    this.xScale = d3
      .scaleTime()
      .domain(d3.extent(this.data, (d) => d.date))
      .range([this.margin.left, this.width - this.margin.right]);

    this.yScale = d3
      .scaleLinear()
      .domain([min, max])
      .nice()
      .range([this.height - this.margin.top, 0]);

    const formatPercent = (d: number) => {
      d = Math.round(d * 100) / 100;
      return `${d > 0 ? `+ ${d}` : d}%`;
    };
    const formatCurrency = (d: number) => String(Math.round(d));

    // Create axis
    this.xAxis = (g: any) =>
      g.attr('transform', `translate(0,${this.height - this.margin.bottom})`).call(
        d3
          .axisBottom(this.xScale)
          .ticks(this.daysDifference < 7 ? this.daysDifference : this.width <= MOBILE_NAVIGATION ? this.width / 100 : 7)
          .tickFormat(formatDate)
          .tickSizeOuter(0)
      );
    this.yAxis = (g: any) =>
      g.attr('text-anchor', 'start').call(
        d3
          .axisLeft(this.yScale)
          .ticks(this.height / 60)
          .tickFormat(this.filterConfig.source === GraphFilterSource.BALANCE ? formatCurrency : formatPercent)
      );
    this.grid = (g: any) =>
      g.attr('class', 'grid').call(
        d3
          .axisLeft(this.yScale)
          .ticks(this.height / 60)
          .tickSize(-this.width)
          .tickFormat(() => ' ')
      );

    svg.append('g').attr('class', 'grid').call(this.grid);

    svg
      .append('path')
      .datum(this.data)
      .attr('class', 'line-graph__path')
      .attr('fill', 'none')
      .attr('stroke', this.cssReportingChartColor)
      .attr('stroke-width', 2.5)
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('filter', `drop-shadow(0 10px 4px ${this.cssReportingChartShadowColor})`);

    svg.append('g').attr('class', 'myXaxis').call(this.xAxis);
    svg.append('g').attr('class', 'myXaxisFake').call(this.xAxis).style('opacity', '0');
    svg.append('g').attr('class', 'myYaxis').call(this.yAxis);

    this.updateChart(this.data);
  }

  updateChart(data: any[], redraw = false): void {
    const min = d3.min(data, (d) => d.value);
    const max = d3.max(data, (d) => d.value);

    // Create scales
    this.xScale = d3
      .scaleTime()
      .domain(d3.extent(data, (d) => d.date))
      .nice()
      .range([0, this.width]);
    this.yScale = d3
      .scaleLinear()
      .domain([min, max])
      .nice()
      .range([this.height - this.margin.top - this.margin.bottom, 40]);

    const svg = d3.select('.line-chart');

    svg.selectAll('.data_point__svg').remove();
    svg.select('.line-graph__tooltip-dot').remove();
    svg.select('.line-graph__tooltip-wrapper').remove();
    svg.select('.line-graph__tooltip').remove();

    // Fake animation on main filter switch
    if (redraw) {
      svg.select('.line-graph__path').datum(data).attr('d', 'M0,110Z');
    }

    // Update main line
    svg
      .select('.line-graph__path')
      .datum(data)
      .transition()
      .duration(700)
      .attrTween('d', () => {
        const previous = d3.select('.line-graph__path').attr('d');
        const current = this.line(data);
        return interpolatePath(previous, current);
      });

    svg
      .append('g')
      .attr('class', 'data_point__svg')
      .selectAll('dot')
      .data(this.transactionsTypeDepositTransfer)
      .enter()
      .append('circle')
      .attr('class', 'data_point data_point--deposit')
      .attr('cx', (d: any) => this.xScale(d.date))
      .attr('cy', (d: any) => this.yScale(d.value))
      .attr('r', 4);

    svg
      .append('g')
      .attr('class', 'data_point__svg')
      .selectAll('dot')
      .data(this.transactionsTypeWithdrawal)
      .enter()
      .append('circle')
      .attr('class', 'data_point data_point--withdrawal')
      .attr('cx', (d: any) => this.xScale(d.date))
      .attr('cy', (d: any) => this.yScale(d.value))
      .attr('r', 4);

    const tooltip = svg.append('g').attr('class', 'line-graph__tooltip-wrapper');

    const a = (a) => {
      const bBox = a.node().getBBox();
      if (bBox.x < 0 || bBox.width + bBox.x > this.width) {
        svg.select('.myXaxis').attr('class', 'myXaxis');
        if (bBox.x < 0 && bBox.width - bBox.x < this.width) {
          svg.select('.myXaxis').attr('class', 'myXaxis myXaxis--left');
        }
        if (bBox.x >= 0 && bBox.width + bBox.x > this.width) {
          svg.select('.myXaxis').attr('class', 'myXaxis myXaxis--right');
        }
      } else {
        svg.select('.myXaxis').attr('class', 'myXaxis myXaxis--short');
      }
    };

    if (this.xAxis && this.yAxis) {
      // Update X axis
      svg.select('.myXaxis').transition().duration(1000).call(this.xAxis);

      svg.select('.myXaxisFake').call(this.xAxis).call(a);

      // Update Y axis
      svg.select('.myYaxis').transition().duration(1000).call(this.yAxis);

      // Update grid
      svg.select('.grid').transition().duration(1000).call(this.grid);
    }

    const dot = svg
      .append('g')
      .attr('class', 'line-graph__tooltip-dot')
      .append('circle')
      .attr('r', 6)
      .attr('stroke', this.cssReportingChartColor)
      .attr('stroke-width', 4)
      .attr('fill', this.cssReportingChartColor)
      .attr('filter', `drop-shadow(0 4px 4px ${this.cssReportingChartShadowColor})`)
      .style('opacity', 0);

    svg.on('touchmove mousemove', (ev) => {
      const expectedEv = window.TouchEvent && ev instanceof TouchEvent ? ev.touches[0] : ev;
      let { date, value, transactions } = this.bisect(d3.pointer(expectedEv, (<any>svg).node())[0]);
      // If there is only one value to show
      if (data.length === 1) {
        date = data[0].date;
        value = data[0].value;
      }
      // If customer point out the line set date and value for last item
      if (!date) {
        date = data[data.length - 1].date;
        value = data[data.length - 1].value;
      }
      // Optimize how xscale is created
      const xScaleDate = this.xScale(date);

      dot.attr('transform', `translate(${xScaleDate},  ${this.yScale(value)})`).style('opacity', 1);

      tooltip.call(this.callout.bind(this), this.formatDate(date), `${Math.round(value * 100) / 100}%`, transactions);

      const tooltipWidth = tooltip.node().getBBox().width;
      const threshold = tooltipWidth / 2;

      let xPosition = 0;
      if (xScaleDate < threshold + 5) {
        xPosition = threshold + 5;
      } else if (xScaleDate > this.width - threshold - 10) {
        xPosition = this.width - threshold - 10;
      } else {
        xPosition = xScaleDate;
      }

      const yPosition = this.yScale(value) - 55;

      tooltip.attr('transform', `translate(${xPosition}, ${yPosition})`);
    });

    // Remove pointer
    svg.on('mouseout touchend', () => {
      tooltip.call(this.callout, null, null, null);
      dot.style('opacity', 0);
    });
  }

  private bisect(mx) {
    const bisectObj = d3.bisector((d: any) => d.date).left;
    const date = this.xScale.invert(mx);
    const index = bisectObj(this.data, date, 1);
    const a = this.data[index - 1];
    const b = this.data[index];
    if (a && a.date && b && b.date) {
      return date - a.date > b.date - date ? b : a;
    }
    return {
      date: 0,
      value: 0
    };
  }

  private callout(g, date: string, value: string, additionalData: Transaction[]) {
    if (!value) {
      return g.style('display', 'none');
    }

    g.style('display', null)
      .attr('class', 'line-graph__tooltip')
      .style('pointer-events', 'none')
      .style('font', '11px sans-serif')
      .style('fill', this.cssGreyColor);

    const dataCheck =
      additionalData && additionalData.length && this.filterConfig.source === GraphFilterSource.BALANCE && this.data.length <= GraphFilterDays.YEAR;
    if (dataCheck) {
      const isDeposit =
        additionalData[0].transaction_type === TransactionType.DEPOSIT || additionalData[0].transaction_type === TransactionType.TRANSFER;
      if ((isDeposit && !this.hideDepositsTransfers) || (!isDeposit && !this.hideWithdrawals)) {
        this.getTransactionValue(additionalData[0]);
      }
    }

    const path = g.selectAll('path').data([null]).join('path').attr('fill', this.cssReportingChartTooltipColor);

    const text = g
      .selectAll('text')
      .attr('class', 'text-tooltip')
      .data([null])
      .join('text')
      .call((text) =>
        text
          .selectAll('tspan')
          .data([`${date}`, `${value}`])
          .join('tspan')
          .attr('text-anchor', 'middle')
          .attr('x', '0')
          .attr('y', (d, i) => `${i * 1.2}em`)
          .text((d) => d)
      );

    const { x, y, width: w, height: h } = text.node().getBBox();

    text.attr('transform', `translate(4,${-2.5 - y})`);
    path.attr('style', `transform: translateY(-15px)`);
    path.attr(
      'd',
      `M${-w / 2 - 7.5},5H${w / 2 + 7.5} a5,5 0 0 1 5,5 v${h + 5} a5,5 0 0 1 -5,5 h-${w + 10} a5,5 0 0 1 -5,-5 v-${h + 5} a5,5 0 0 1 5,-5 z`
    );
  }

  getTransactionValue(transation: Transaction): any {
    const isWithdrawal = transation.transaction_type === TransactionType.WITHDRAWAL;
    let output = (isWithdrawal ? '-' : '+') + this.currency;
    if (isWithdrawal) {
      output = `${output} ${transation.transaction_value * -1}`;
    } else {
      output = `${output} ${transation.transaction_value}`;
    }
    return output;
  }

  private formatDate(date: Date) {
    const mo = new Intl.DateTimeFormat(this.currentLang, { month: 'short' }).format(date);
    const da = new Intl.DateTimeFormat(this.currentLang, { day: '2-digit' }).format(date);
    const yy = date.getFullYear();
    return `${da} ${mo} ${yy}`;
  }
}
